export default "__VITE_ASSET__SIQmp1Gk__"